import styled from 'styled-components';

export const ServiceCalendarItemStyle = styled.div(props => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2px",
    marginBottom: "1px",
    ...props,
}))